package com.svdsak

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.svdsak.util.Res
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import org.jetbrains.compose.web.css.vh

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    LaunchedEffect(Unit) {
        window.addEventListener("contextmenu", {
            it.preventDefault()
        })
    }
    SilkApp {
        Surface(
            SmoothColorStyle.toModifier()
                .minHeight(100.vh)
                .background(Res.WEBSITE_BG_COLOR)
                .fontFamily("Akaya Kanadaka")
                .scrollBehavior(ScrollBehavior.Smooth)
        ) {
            content()
        }
    }
}
